import React, { useState } from 'react'
import {
  MotifCard,
  MotifCardHeader,
  MotifCardBody,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react'
import { IconoirUpload } from '@ey-xd/motif-icon'
import UploadDocument from './UploadDocument/UploadDocument'
import List from '@/features/engagement/HRList/List'
import './HRList.scss'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { EngagementDetail } from '@/services/types'

export default function HRList() {
  const listHRDocumentState = useSelector((state: any) => state.HRList.HRList)
  const currentEngagement = useSelector(
    (state: { clientCard: { currentEngagement: EngagementDetail } }) =>
      state.clientCard.currentEngagement,
  )
  const isArchived = currentEngagement?.isArchived
  // engagement not loaded yet (e.g. direct navigation) - isArchived would be undefined, so gate on load too
  const isEngagementLoaded = !!currentEngagement?.engagementID
  const [showHRUpload, setHRUpload] = useState(false)
  const [uploadDocId, setUploadDocId] = useState<string>('')

  return (
    <>
      <div className="motif-row">
        <div className="motif-col-lg-12">
          <MotifCard
            className="hr-list-container"
            orientation="horizontal"
            variant="full-width"
          >
            <MotifCardHeader>
              <div className="motif-container">
                <div className="motif-row">
                  <div className="motif-col-lg-10">
                    <span className="motif-h6-default-regular">
                      HR User Listing
                    </span>
                    <div className="motif-card-subheader">
                      <span className="motif-body2-default-regular sub-header">
                        Upload the client HR list and map the columns to establish key identifiers essential for the Segregation of Duties (SoD) 
                        analysis between developers and implementers.
                      </span>
                    </div>
                  </div>
                  <div className="motif-col-lg-2 upload-button">
                    {isEngagementLoaded && !isArchived && (
                      <MotifButton
                        size="small"
                        type="button"
                        variant="primary"
                        onClick={() => setHRUpload(true)}
                      >
                        <MotifIcon
                          iconFunction={IconoirUpload}
                          title="Upload HR document"
                        />
                        Upload
                      </MotifButton>
                    )}
                  </div>
                </div>
              </div>
            </MotifCardHeader>
            <MotifCardBody
              className={classNames({
                'text-center': Object.values(listHRDocumentState).length === 0,
              })}
            >
              <List isListUpdated={uploadDocId} />
            </MotifCardBody>
          </MotifCard>
        </div>
      </div>
      <UploadDocument
        isVisible={showHRUpload}
        setIsVisible={setHRUpload}
        setUploadDocId={setUploadDocId}
      />
    </>
  )
}
